import React, { useState, useMemo, useEffect } from "react";
import { TextField } from "@mui/material";
import debounce from "lodash.debounce";

export default function SearchTableData({ onSearch = () => {}, delay = 500 }) {
  const [searchTerm, setSearchTerm] = useState("");


  const debouncedSearch = useMemo(() => {
    return debounce((value) => {
      onSearch(value.trim());
    }, delay);
  }, [onSearch, delay]);


  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    debouncedSearch(value);
  };

  return (
    <TextField
      fullWidth
      label="Search"
      size="small"
      variant="standard"
      placeholder="Search Item"
      value={searchTerm}
      onChange={handleSearchChange}
      inputProps={{ "aria-label": "Search Items" }}
    />
  );
}
